class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverMediaQuery = window.matchMedia('(min-width: 990px)');
    this.onMouseEnter = this.handleMouseEnter.bind(this);
    this.onMouseLeave = this.handleMouseLeave.bind(this);
    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  handleMouseEnter() {
    if (!this.hoverMediaQuery.matches) return;

    window.clearTimeout(this.closeTimer);
    this.openOnHover();
  }

  handleMouseLeave() {
    if (!this.hoverMediaQuery.matches) return;

    this.closeTimer = window.setTimeout(() => {
      this.close();
    }, 120);
  }

  openOnHover() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    const openMenus = this.header?.querySelectorAll('header-menu details[open]') || [];

    openMenus.forEach((openMenu) => {
      if (openMenu === this.mainDetailsToggle) return;
      openMenu.removeAttribute('open');
      openMenu.querySelector('summary')?.setAttribute('aria-expanded', false);
    });

    this.mainDetailsToggle.setAttribute('open', '');
    summary.setAttribute('aria-expanded', true);
    this.onToggle();
  }

  close() {
    window.clearTimeout(this.closeTimer);
    super.close();

    if (this.header) {
      this.header.preventHide = false;
    }
  }
}

customElements.define('header-menu', HeaderMenu);
